//策略组 有什么要加的的验证加这里面
let strategies = {
  //是否非空
  isNoneEmpty: function (value, errorMsg) {
    if (value === null || value === undefined || value === "") {
      return errorMsg;
    }
  },
  //手机号正则
  isMobile: function (value, errorMsg) {
    let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
    if (!reg.test(value)) {
      return errorMsg;
    }
  },
  //比大小 value要传数组
  isBigger: function (value, errorMsg) {
    errorMsg = `${value[0]}大于${value[1]}`;
    if (value[1] < value[0]) {
      return errorMsg;
    }
  },
  //比大小LPN版
  isBigger_grid: function (value, errorMsg) {
    let startLetter = value[0][0].charCodeAt();
    let endLetter = value[1][0].charCodeAt();
    let startNum = value[0].slice(1);
    let endNum = value[1].slice(1);
    errorMsg = `${value[0]}大于${value[1]}`;
    if (startLetter > endLetter) {
      return errorMsg;
    } else if (startLetter == endLetter) {
      if (startNum > endNum) {
        return errorMsg;
      }
    }
  },
  //数字1-9是否SS格式
  isSS: function (value, errorMsg) {
    let isNum = !isNaN(value);
    if (!isNum) {
      return "请输入数字";
    }
    if (value < 10 && value > 0) {
      if (String(value).length != 2 && String(value)[0] != "0") {
        return errorMsg;
      }
    } else {
      return errorMsg;
    }
  },
  //数字范围1-99
  is2LengthNum: function (value, errorMsg) {
    if (value < 1 && value > 99) {
      return errorMsg;
    }
  },
  //是否字母加数字
  isLPN: function (value, errorMsg) {
    let isLetter = value[0].charCodeAt();
    isLetter = isLetter > 64 && isLetter < 91;
    let isNum = !isNaN(value.slice(1));
    if (!isNum || !isLetter) {
      return errorMsg;
    }
  },
  //isLPN变种数字在1-99
  isLPNGrid: function (value, errorMsg) {
    let isLetter = value[0].charCodeAt();
    isLetter = isLetter > 64 && isLetter < 91;
    let isNum = !isNaN(value.slice(1));
    isNum = isNum
      ? value.slice(1) > 0 && Math.ceil(value.slice(1)) < 100
      : isNum;
    if (!isNum || !isLetter) {
      return errorMsg;
    }
  },
};

class Validator {
  //接收一个定制的策略对象添加到策略组里
  constructor(func) {
    if (func) {
      strategies = Object.assign(strategies, func);
    }
    this.cache = [];
  }
  //验证单条用add 会比较简洁易读
  //要是想要代码统一一点都用add_batch也行
  add(value, rule, errorMsg) {
    let ary = rule.split(":");
    this.cache.push(function () {
      let strategy = ary.shift();
      ary.unshift(value);
      ary.push(errorMsg);
      return strategies[strategy].apply(null, ary);
    });
  }
  add_batch(value, rules) {
    let that = this;
    for (let i = 0, length = rules.length; i < length; i++) {
      (function (rule) {
        let ary = rule.strategy.split(":");
        let errorMsg = rule.errorMsg;
        that.cache.push(function () {
          let strategy = ary.shift();
          ary.unshift(value);
          ary.push(errorMsg);
          return strategies[strategy].apply(null, ary);
        });
      })(rules[i]);
    }
  }
  //多个对象需要用同样的策略
  loopAdd(value, rule, errorMsg) {
    value.forEach((item) => {
      this.add(item, rule, errorMsg);
    });
  }
  loopAdd_batch(value, rules) {
    value.forEach((item) => {
      this.add_batch(item, rules);
    });
  }
  start() {
    if (this.cache.length == 0) {
      return;
    }
    for (let i = 0, length = this.cache.length; i < length; i++) {
      let validatorFunc = this.cache[i];
      let errorMsg = validatorFunc();
      if (errorMsg) {
        return errorMsg;
      }
    }
  }
}

export { Validator };

//使用方法
//let validator = new Validator(function)
// validator.add(参数, "策略", "报错信息");
// validator.add_batch(
//   参数,[{strategy:'策略',errorMsg:'报错信息'}，{strategy:'策略',errorMsg:'报错信息'}]
// );
